'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./~/ipld-eth-account-snapshot/src/index.js
// module id = 546
// module chunks = 0